import {RouteConfig} from "vue-router";
import {createPublicRoute, createSecureCompetitionMetadata, createSecureReadOnlyRouteMetadata} from "@/router";

const ROOT = '/competitions';
const routes: Array<RouteConfig> = [
    {
        path: ROOT + '/',
        component: () => import(/* webpackChunkName: "module-competition" */ "@/modules/competition/views/CompetitionCalendarView.vue"),
        meta: createPublicRoute()
    }, {
        path: ROOT + '/create',
        component: () => import(/* webpackChunkName: "module-competition-create" */ "@/modules/competition/views/CreateCompetitionView.vue"),
        meta: createSecureCompetitionMetadata()
    },
    {
        path: ROOT + '/:competition',
        component: () => import(/* webpackChunkName: "module-competition-profile" */ "@/modules/competition/views/public/CompetitionProfileLayout.vue"),
        children: [
            {
                path: '/',
                component: () => import(/* webpackChunkName: "module-competition-profile" */ "@/modules/competition/views/public/CompetitionTimescheduleView.vue"),
                meta: createPublicRoute()
            },
            {
                path: 'info',
                component: () => import(/* webpackChunkName: "module-competition-profile" */ "@/modules/competition/views/public/CompetitionInfoView.vue"),
                meta: createPublicRoute()
            },
            {
                path: 'activity/:activity',
                component: () => import(/* webpackChunkName: "module-competition-profile" */ "@/modules/competition/views/public/CompetitionStartlistView.vue"),
                meta: createPublicRoute()
            },
            {
                path: 'championship-ranking/:ranking',
                component: () => import(/* webpackChunkName: "module-competition-profile" */ "@/modules/competition/views/public/ChampionshipRankingView.vue"),
                meta: createPublicRoute()
            },
            {
                path: 'competition-ranking/:ranking',
                component: () => import(/* webpackChunkName: "module-competition-profile" */ "@/modules/competition/views/public/CompetitionRankingView.vue"),
                meta: createPublicRoute()
            },
            {
                path: 'masterlist',
                component: () => import(/* webpackChunkName: "module-competition-profile" */ "@/modules/competition/views/public/CompetitionMasterlistView.vue"),
                meta: createPublicRoute()
            }
        ]
    },
    {
        path: ROOT + '/:competition/manage',
        component: () => import(/* webpackChunkName: "module-competition-manage" */ "@/modules/competition/views/manage/CompetitionManageLayout.vue"),
        children: [
            {
                path: '',
                redirect: ROOT + '/:competition/manage/tests'
            },
            {
                path: 'competition',
                component: () => import(/* webpackChunkName: "module-competition-manage" */ "@/modules/competition/views/manage/competition/View.vue"),
                meta: createSecureReadOnlyRouteMetadata(),
                name: 'manage-competition',
                children: [
                    {
                        path: '',
                        component: () => import(/* webpackChunkName: "module-competition-manage" */ "@/modules/competition/views/manage/competition/general/GeneralPanel.vue"),
                        meta: createSecureReadOnlyRouteMetadata()
                    },
                    {
                        path: 'live',
                        component: () => import(/* webpackChunkName: "module-competition-manage" */ "@/modules/competition/views/manage/competition/live/LivePanel.vue"),
                        meta: createSecureReadOnlyRouteMetadata()
                    },
                    {
                        path: 'officials',
                        component: () => import(/* webpackChunkName: "module-competition-manage" */ "@/modules/competition/views/manage/competition/officials/OfficialsPanel.vue"),
                        meta: createSecureReadOnlyRouteMetadata()
                    },
                    {
                        path: 'finance',
                        component: () => import(/* webpackChunkName: "module-competition-manage" */ "@/modules/competition/views/manage/competition/financial/FinancialPanel.vue"),
                        meta: createSecureReadOnlyRouteMetadata()
                    },
                    {
                        path: 'registration',
                        component: () => import(/* webpackChunkName: "module-competition-manage" */ "@/modules/competition/views/manage/competition/registration/CompetitionRulesPanel.vue"),
                        meta: createSecureReadOnlyRouteMetadata()
                    },
                    {
                        path: 'approutes',
                        component: () => import(/* webpackChunkName: "module-competition-manage" */ "@/modules/competition/views/manage/competition/approutes/AppRoutesPanel.vue"),
                        meta: createSecureReadOnlyRouteMetadata()
                    },
                    {
                        path: 'customattributes',
                        component: () => import(/* webpackChunkName: "module-competition-manage" */ "@/modules/competition/views/manage/competition/customattributes/CustomAttributesPanel.vue"),
                        meta: createSecureReadOnlyRouteMetadata()
                    },
                    {
                        path: 'additionalsettings',
                        component: () => import(/* webpackChunkName: "module-competition-manage" */ "@/modules/competition/views/manage/competition/additional/AdditionalSettingsPanel.vue"),
                        meta: createSecureReadOnlyRouteMetadata()
                    }
                ],
            },
            {
                path: 'tests',
                component: () => import(/* webpackChunkName: "module-competition-manage" */ "@/modules/competition/views/manage/tests/View.vue"),
                meta: createSecureReadOnlyRouteMetadata(),
                name: 'manage-tests'
            },
            {
                path: 'subscriptions',
                component: () => import(/* webpackChunkName: "module-competition-manage" */ "@/modules/competition/views/manage/subscriptions/View.vue"),
                meta: createSecureReadOnlyRouteMetadata(),
                children: [
                    {
                        path: '',
                        component: () => import(/* webpackChunkName: "module-competition-manage" */ "@/modules/competition/views/manage/subscriptions/masterlist/RegistrationMasterlistView.vue"),
                        meta: createSecureReadOnlyRouteMetadata()
                    },
                    {
                        path: 'list/:ref',
                        component: () => import(/* webpackChunkName: "module-competition-manage" */ "@/modules/competition/views/manage/subscriptions/ContentPanel.vue"),
                        meta: createSecureReadOnlyRouteMetadata()
                    }
                ],
                name: 'manage-registrations'
            },
            {
                path: 'timeschedule',
                component: () => import(/* webpackChunkName: "module-competition-manage" */ "@/modules/competition/views/manage/timeschedule/View.vue"),
                meta: createSecureReadOnlyRouteMetadata(),
                name: 'manage-timeschedule'
            },
            {
                path: 'startlists',
                component: () => import(/* webpackChunkName: "module-competition-manage" */ "@/modules/competition/views/manage/startlist/View.vue"),
                meta: createSecureReadOnlyRouteMetadata(),
                name: 'manage-startlists'
            },
            {
                path: 'results',
                component: () => import(/* webpackChunkName: "module-competition-manage" */ "@/modules/competition/views/manage/results/View.vue"),
                meta: createSecureReadOnlyRouteMetadata(),
                name: 'manage-results'
            },
            {
                path: 'rankings',
                component: () => import(/* webpackChunkName: "module-competition-manage" */ "@/modules/competition/views/manage/ranking/View.vue"),
                meta: createSecureReadOnlyRouteMetadata(),
                name: 'manage-rankings'
            },
            {
                path: 'finance',
                component: () => import(/* webpackChunkName: "module-competition-manage" */ "@/modules/competition/views/manage/finance/View.vue"),
                meta: createSecureReadOnlyRouteMetadata(),
                children: [
                    {
                        path: '',
                        alias: '',
                        component: () => import("@/modules/competition/views/manage/finance/CompetitionFinanceItemsView.vue"),
                        meta: createSecureReadOnlyRouteMetadata()
                    },
                    {
                        path: 'transfers',
                        alias: '',
                        component: () => import("@/modules/competition/views/manage/finance/CompetitionFinanceSplitView.vue"),
                        meta: createSecureReadOnlyRouteMetadata()
                    },
                    {
                        path: 'payout',
                        alias: '',
                        component: () => import("@/modules/competition/views/manage/finance/CompetitionFinancePayoutView.vue"),
                        meta: createSecureReadOnlyRouteMetadata()
                    },
                ],
                name: 'manage-finance'
            },
            {
                path: 'toolbox',
                component: () => import(/* webpackChunkName: "module-competition-manage" */ "@/modules/competition/views/manage/toolbox/View.vue"),
                meta: createSecureReadOnlyRouteMetadata(),
                children: [
                    {
                        path: '',
                        alias: '',
                        component: () => import("@/modules/competition/views/manage/toolbox/Overview.vue"),
                        meta: createSecureReadOnlyRouteMetadata()
                    },
                    {
                        path: 'hippomundo',
                        alias: '',
                        component: () => import("@/modules/competition/views/manage/toolbox/hippomundo/HippomundoStartlistEnricher.vue"),
                        meta: createSecureReadOnlyRouteMetadata()
                    },
                    {
                        path: 'sync-practitioners',
                        alias: '',
                        component: () => import("@/modules/competition/views/manage/toolbox/sync-practitioners/SyncCompetitionPractitionersView.vue"),
                        meta: createSecureReadOnlyRouteMetadata()
                    }
                ],
                name: 'manage-toolbox'
            },
        ]
    }
];

export default {
    routes: routes
};
